import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";
import { InputObject } from "../controls/default";
import { createSearchRequest } from "../hooks/useSearchRequest";
import { getCompanyIndustries } from "../repository/data.repository";

export interface AssetTypesViewForm {
  readonly name: string;
  readonly description: string;
  readonly domain?: InputObject;
}

export const assetTypesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 320,
    sort: true,
  },
  {
    title: "Industry",
    key: "domainName",
    width: 160,
    sort: true,
  },
  {
    title: "Subtypes",
    key: "subtypesCount",
    width: 110,
    sort: true,
  },
  {
    title: "Assets",
    key: "assetsCount",
    width: 110,
    sort: true,
  },
];

const assetTypesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
  {
    formField: "domain",
    queryField: "domainUid",
    operation: QueryOperation.Equal,
    transform: comboboxValue,
  },
];

export const mapAssetTypesViewQuery = (
  values: AssetTypesViewForm,
): SearchQuery => buildSearchQuery(values, assetTypesQueryMappings);

export const assetTypesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
        {
          type: "combobox",
          name: "domain",
          label: "Industry",
          request: createSearchRequest(getCompanyIndustries, "name"),
        },
      ],
    },
  ],
};
